export default {
    title: 'Massenbearbeitung',

    selectProcesses: 'Bitte gehen Sie in die Maßnahmenübersicht, wählen Sie dort die gewünschten Maßnahmen aus und wählen Sie dann das Werkzeug "Massenbearbeitung" aus.',

    subsidyAmountPercentageOfSubsidyMax: 'Zuschusshöhe - % von höchstmöglicher Förderung',
    subsidyAmountFromSum: 'Zuschusshöhe – gleiche Teile der Gesamtsumme',
    subsidyGrantedAtForAll: 'Bewilligt am',
    forAll: 'Für alle übernehmen',
    approveAll: 'Alle genehmigen',
    rejectAll: 'Alle ablehnen',

    subsidyAmount: 'Zuschusshöhe',

    saveSuccess: 'Die Maßnahmen wurde erfolgreich gespeichert.',
}